import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom';

const SearchItem = (props) => {
    
    const [keyword, setKeyword] = useState([]);

    const moveTo = (url) => {
        window.open(url, '_blank');
    }
    const getList = () => {
        const getPath = (path) =>{
            var array = JSON.parse(path);
            const pathobj = [];
            for(let i = 0; i < array.length; i++){
                pathobj.push(<span className='path-doc'>{array[i]}</span>);
                if(i < array.length-1)
                    pathobj.push(<i className='icoKdc12 next'></i>);
            }
            return (
                <div className="path">
                    {pathobj}
                </div>
            );
        }
        if (props.result.length == 0) {
            return (
                <div className="result-list">
                    <h3 className='result-keyword'>{props.keyword}</h3>
                    <p className='result-msg'>검색결과 <span>{props.result.length}</span> 개</p>
                </div>
            );
        }
        return (
            <div className="result-list">
                <h3 className='result-keyword'>{props.keyword}</h3>
                <p className='result-msg'>검색결과 <span>{props.result.length}</span> 개</p>
                <ul className='result-list-wrap'>
                    {props.result.map(m => {
                        return (
                            <li className='result-list-each'>
                                <p className='result-title' onClick={()=> moveTo(m.url)}>{m.title}</p>
                                {getPath(m.path)}
                                <p className='result-cnts' dangerouslySetInnerHTML={{ __html: m.content.replace(/\n/g, '<br/>') }}></p>
                            </li>
                        );
                    })}
                </ul>                 
            </div>
        );
    }
    return (
        <div className="result-wrap">
            <div className="filter" style={{display:'none'}}>
                <div className="product-filter" >
                    <div className="product-filter-top">
                        <p className="product-filter-title">제품군</p>
                    </div>
                    <ul className="product-filter-list">
                        <li className="product-filter-list-each">
                            <input type="checkbox" id='product-01'/>
                            <label for='product-01'></label>
                            <label className='check-txt' for='product-01'>K-System Genuine</label>
                        </li>
                        <li className="product-filter-list-each">
                            <input type="checkbox" id='product-02'/>
                            <label for='product-02'></label>
                            <label className='check-txt' for='product-02'>K-System Ace</label>
                        </li>
                        <li className="product-filter-list-each">
                            <input type="checkbox" id='product-03'/>
                            <label for='product-03'></label>
                            <label className='check-txt' for='product-03'>K-System Mobile</label>
                        </li>
                    </ul>
                </div>
                <div className='tag-filter'>
                    <div className="search-filter">
                        <i className='icoKdc24 magnifier-b'></i>
                        <input type="text" />
                    </div>
                    <div className="keywords">
                        <div className="keyword-each">
                            <p>태그태그</p>
                            <div className="btn-delete" >
                                <i className="icoKdc12 delete"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {getList()}              
        </div>
    );
}
export default SearchItem;